import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EditableTextComponent } from '../../../base/text/editable-text/editable-text.component';
import { EditableImageComponent } from '../../../base/image/editable-image/editable-image.component';
import { FileType } from '../../../../state-management/model/enums/state.enums';
import { CoordinatesSystem, ImageFormat, NoBreakpoints } from '../../../../state-management/model/enums/screen-size.enums';
import { ImageCoordinates } from '../../../../state-management/model/interfaces/screen-size.model';
import { BaseComponent } from '../../base/base.component';

@Component({
    selector: 'app-base-feature-banner',
    imports: [
        EditableTextComponent,
        EditableImageComponent
    ],
    templateUrl: './base-feature-banner.component.html',
    styleUrl: './base-feature-banner.component.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseFeatureBannerComponent extends BaseComponent {
  public supportedFileTypes = [FileType.WEBP, FileType.PNG];

  override labelMap = {
    title: 'title',
    subtitle: 'subtitle',
    icon: 'icon'
  };

  override imageReference: ImageCoordinates = {
    coordinatesSystem: CoordinatesSystem.NoCoordinates,
    formatMap: {
      [NoBreakpoints.Unset]: ImageFormat.OneToOne,

    }
  };
}